module.exports = __webpack_public_path__ + "media/images/logo-25f273e3d4d6733b0eb8a3813bf75919.png";